export const MENUITEMS = [
  {
    menutitle: "General",
    menucontent: "Dashboards,Widgets",
    Items: [
      {
        title: "Dashboard",
        icon: "home",
        type: "sub",
        badge: "badge badge-light-primary",
        badgetxt: "5",
        active: false,
        allowedRoles: ["R1", "R2", "R3", "R4"],
        children: [
          { path: `${process.env.PUBLIC_URL}/dashboard/default`, title: "Admin", type: "link", allowedRoles: ["R1"] },
          { path: `${process.env.PUBLIC_URL}/dashboard/UserRVOPV`, title: "UserRVOPV", type: "link", allowedRoles: ["R1", "R2"] },
          { path: `${process.env.PUBLIC_URL}/dashboard/UserQLT`, title: "UserQLT", type: "link", allowedRoles: ["R1", "R2"] },
          { path: `${process.env.PUBLIC_URL}/dashboard/UserCheckIn`, title: "UserCheckIn", type: "link", allowedRoles: ["R1", "R3"] },
          { path: `${process.env.PUBLIC_URL}/dashboard/UserQuiz`, title: "UserQuiz", type: "link", allowedRoles: ["R1", "R4"] }
        ]
      }
    ]
  },
  {
    menutitle: "Applications",
    menucontent: "Ready to use Apps",
    Items: [
      {
        title: "App RVOPV",
        icon: "project",
        type: "sub",
        badge: "badge badge-light-secondary",
        badgetxt: "New",
        active: false,
        allowedRoles: ["R1"],
        children: [
          { path: `${process.env.PUBLIC_URL}/app/projectRVOPV/banner-management`, type: "link", title: "Banner Management", allowedRoles: ["R1", "R2"] },
          { path: `${process.env.PUBLIC_URL}/app/projectRVOPV/minigame-management`, type: "link", title: "MiniGame Management", allowedRoles: ["R1", "R2"] },
          { path: `${process.env.PUBLIC_URL}/app/projectRVOPV/loading-screen-management`, type: "link", title: "Loading Screen Management", allowedRoles: ["R1", "R2"] }
        ]
      },
      {
        title: "App QLT",
        icon: "file",
        type: "sub",
        badge: "badge badge-light-secondary",
        badgetxt: "New",
        active: false,
        allowedRoles: ["R1", "R2"],
        children: [
          { path: `${process.env.PUBLIC_URL}/app/projectQLT/wheel-management`, type: "link", title: "Wheel Management", allowedRoles: ["R1", "R2"] },
          { path: `${process.env.PUBLIC_URL}/app/projectQLT/banner-management`, type: "link", title: "Banner Management", allowedRoles: ["R1", "R2"] },
          { path: `${process.env.PUBLIC_URL}/app/projectQLT/loading-screen-management`, type: "link", title: "Loading Screen Management", allowedRoles: ["R1", "R2"] },
          { path: `${process.env.PUBLIC_URL}/app/projectQLT/image-wheel-management`, type: "link", title: "Image Wheel Management", allowedRoles: ["R1", "R2"] },
          { path: `${process.env.PUBLIC_URL}/app/projectQLT/image-background-management`, type: "link", title: "Image Background Management", allowedRoles: ["R1", "R2"] }
        ]
      },
      {
        title: "App CheckIn Event",
        icon: "ecommerce",
        type: "sub",
        active: false,
        allowedRoles: ["R1", "R3"],
        children: [
          { path: `${process.env.PUBLIC_URL}/app/event/banner-management`, title: "Banner Management", type: "link", allowedRoles: ["R1", "R3"] },
          { path: `${process.env.PUBLIC_URL}/app/event/event-management`, title: "Event Management", type: "link", allowedRoles: ["R1", "R3"] },
          { path: `${process.env.PUBLIC_URL}/app/event/user-event-reg`, title: "User Event Reg", type: "link", allowedRoles: ["R1", "R3"] }
        ]
      },
      {
        title: "App Quiz",
        icon: "knowledgebase",
        type: "sub",
        active: false,
        allowedRoles: ["R1", "R4"],
        children: [
          { path: `${process.env.PUBLIC_URL}/app/quiz-app/alert`, icon: "bell", title: "Alert Management", type: "link", allowedRoles: ["R1", "R4"] },
          { path: `${process.env.PUBLIC_URL}/app/quiz-app/step`, icon: "list-ol", title: "Step Management", type: "link", allowedRoles: ["R1", "R4"] },
          { path: `${process.env.PUBLIC_URL}/app/quiz-app/dynamic-form-field`, icon: "wpforms", title: "Dynamic Form Field", type: "link", allowedRoles: ["R1", "R4"] },
          { path: `${process.env.PUBLIC_URL}/app/quiz-app/reward`, icon: "award", title: "Reward Management", type: "link", allowedRoles: ["R1", "R4"] },
          { path: `${process.env.PUBLIC_URL}/app/quiz-app/loading-screen`, icon: "spinner", title: "Loading Screen Management", type: "link", allowedRoles: ["R1", "R4"] },
          { path: `${process.env.PUBLIC_URL}/app/quiz-app/quiz`, icon: "question-circle", title: "Quiz Management", type: "link", allowedRoles: ["R1", "R4"] }
        ]
      }
    ]
  }
];
